var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-row",
          { attrs: { type: "flex", gutter: 4 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "selected_form",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "Chọn phiếu",
                    },
                    on: { change: _vm.handleSearchResultByIdName },
                    model: {
                      value: _vm.indexForm,
                      callback: function ($$v) {
                        _vm.indexForm = $$v
                      },
                      expression: "indexForm",
                    },
                  },
                  _vm._l(_vm.forms, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        value: index,
                        label: `(FORM_${
                          item.idForm
                        }_${_vm.formatDateTimeParseCode(item.createdDate)}) - ${
                          item.nameForm
                        }`,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", [_vm._t("default", null, { filter: _vm.dataForm })], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }